import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux"
import store from "./store/index";

import './i18n/configs'; //multilang

import { Helmet, HelmetProvider } from 'react-helmet-async';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//  <React.StrictMode>
    
    <Provider store={store}>
        <HelmetProvider>
        <Helmet>
            <title>Project monoNoFuT</title>
            <meta name="description" content='This is Project monoNoFuT. The NFT Project that is about the cyborgs in the Crypto exchanges in NEO-EDO.'/>
        </Helmet>
        <App />
        </HelmetProvider>
    </Provider>
//  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
